/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {configureAdminResourceStates} from '../common/controller/admin-resource-routing';
import {SiteCopyModalComponent} from './site-copy-modal.component';
import {ALL_COUNTRIES} from '../common/directives/country-select/countries';
import {AdnSortingHeaderParam} from '../common/directives/html/sorting-header.component';
import _ from 'lodash';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {AdUnitResource} from '../../components/api/resources/resource/adunit.resource';
import {SiteResource} from '../../components/api/resources/resource/site.resource';


export function siteStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('sites.site', SiteResource, AdUnitResource, 'app.inv', 'app');
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'Site',
          editTag: 'adn-site-edit-page',
          twoPanel: {
            rightTag: 'adn-site-analysis-page'
          },
          listTag: 'adn-site-list-page',
          listResolve: {
            extension: /*@ngInject*/ function() {
              return {
                func: function(ctrl, afterFill) {
                  if (afterFill) {
                    const afterFillCache = {};
                    _.forEach(ctrl.items, function(item) {
                      const foundCountry = afterFillCache[item.country] || _.find(ALL_COUNTRIES, function(c) {
                        return c.code === item.country;
                      });
                      if (foundCountry) {
                        item.countryName = foundCountry.name;
                        afterFillCache[foundCountry.code] = _.cloneDeep(foundCountry);
                      } else {
                        item.countryName = item.country;
                      }
                    });
                    return;
                  }
    
                  ctrl.allCountries = _.filter(LocalNetworkInfo.obtain().getSiteCountries(), function(c) {
                    return c.country;
                  });
    
                  const activeMerchants = _.filter(LocalNetworkInfo.obtain().getInfo('productFeedProductCounts') || [], function(feed) {
                    return feed.productCount > 0;
                  });
                  ctrl.showMerchantColumn = activeMerchants.length > 1;
                  ctrl.merchantsById = {};
                  _.forEach(activeMerchants, function(m) {
                    if (m && _.isFinite(m.id)) {
                      ctrl.merchantsById[m.id] = m;
                      ctrl.merchantsById[String(m.id)] = m;
                    }
                  });
                  ctrl.merchantSummaryForSite = function(site) {
                    if (!site) {
                      return '';
                    }
                    const mids = site.retailMerchantIds;
                    const arr = _.isArray(mids) ? _.uniq(_.filter(_.map(mids, function(mid) {
                      return _.isString(mid) ? parseInt(mid, 10) : mid;
                    }), _.isFinite)) : [];
                    if (!arr.length) {
                      return 'All';
                    }
                    return _.map(arr, function(id) {
                      const merchant = ctrl.merchantsById[id];
                      return (merchant && (merchant.uiTitle || merchant.title)) || String(id);
                    }).join(', ');
                  };
    
                  const sortParams: AdnSortingHeaderParam[] = ['name', 'siteUrl', 'country'];
                  if (ctrl.showMerchantColumn) {
                    sortParams.push({param: '', labelInstant: 'Merchant'});
                  }
                  sortParams.push(
                    {label: 'siteGroup', param: 'SiteGroup'},
                    {label: 'earningsAccount', param: 'EarningsAccount'},
                    {label: 'status', param: 'requestedInLastDay'}
                  );
                  ctrl.siteListSortParams = sortParams;
    
                  const cache = {};
                  function getCountryName(countries) {
                    _.forEach(countries, function(item) {
                      const foundCountry = cache[item.country] || _.find(ALL_COUNTRIES, function(c) {
                        return c.code === item.country;
                      });
                      if (foundCountry) {
                        item.countryName = foundCountry.name;
                        cache[foundCountry.code] = _.cloneDeep(foundCountry);
                      } else {
                        item.countryName = item.country;
                      }
                    });
                  }
                  getCountryName(ctrl.allCountries);
                  getCountryName(ctrl.items);
    
                  ctrl.getName = function(code) {
                    return cache[code] ? cache[code].name : '';
                  };
                }
              };
            }
          },
          itemResolve: {
            earningsAccountFromParam: /*@ngInject*/ function($stateParams) {
              if ($stateParams.earningsAccountId && $stateParams.earningsAccountName) {
                return {
                  id: $stateParams.earningsAccountId,
                  name: $stateParams.earningsAccountName,
                  country: $stateParams.earningsAccountCountry,
                  ownerTeamId: $stateParams.earningsAccountOwnerTeamId
                };
              }
            },
            applyEarningsAccountFromParam: /*@ngInject*/ function(model, $stateParams, earningsAccountFromParam) {
              if ($stateParams.isNew && earningsAccountFromParam) {
                model.earningsAccount = {id: earningsAccountFromParam.id, name: earningsAccountFromParam.name};
                model.country = earningsAccountFromParam.country;
                model.ownerTeam = {id: earningsAccountFromParam.ownerTeamId};
              }
            },
            copyConfig: function() {
              return {
                modalComponent: SiteCopyModalComponent,
                stateUrl: 'app.inv.sites.site',
                lcase: 'site',
                ucase: 'Site'
              };
            }
          },
          crumbParams: ['EarningsAccount']
        });
  }, adnRouterHelper);
}
